(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8738:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(7607);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(2322);
// EXTERNAL MODULE: ./node_modules/@starknet-react/core/dist/index.module.js + 1 modules
var index_module = __webpack_require__(904);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ./src/components/CountDown.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


var useCountdown = function(props) {
    var countDownDate = new Date(parseInt(props.date)).getTime();
    var ref = (0,react.useState)(countDownDate - new Date().getTime()), countDown = ref[0], setCountDown = ref[1];
    (0,react.useEffect)(function() {
        var interval = setInterval(function() {
            setCountDown(countDownDate - new Date().getTime());
        }, 1000);
        return function() {
            return clearInterval(interval);
        };
    }, [
        countDownDate
    ]);
    return getReturnValues(countDown);
};
var getReturnValues = function(countDown) {
    // calculate time left
    var days = Math.floor(countDown / (1000 * 60 * 60 * 24));
    var hours = Math.floor(countDown % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
    var minutes = Math.floor(countDown % (1000 * 60 * 60) / (1000 * 60));
    var seconds = Math.floor(countDown % (1000 * 60) / 1000);
    return [
        days,
        hours,
        minutes,
        seconds
    ];
};
var DateTimeDisplay = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "mr-1 ".concat(props.isDanger ? "countdown danger" : "countdown"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            children: [
                props.value,
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "text-gray-600",
                    children: props.type
                })
            ]
        })
    });
};
var ExpiredNotice = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "expired-notice",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "Expired!!!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Please select a future date and time."
            })
        ]
    });
};
var ShowCounter = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex text-3xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeDisplay, {
                value: props.days,
                type: "D",
                isDanger: props.days <= 3
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeDisplay, {
                value: props.hours,
                type: "H",
                isDanger: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeDisplay, {
                value: props.minutes,
                type: "M",
                isDanger: false
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DateTimeDisplay, {
                value: props.seconds,
                type: "S",
                isDanger: false
            })
        ]
    });
};
var CountdownTimer = function(props) {
    var ref = _slicedToArray(useCountdown(props), 4), days = ref[0], hours = ref[1], minutes = ref[2], seconds = ref[3];
    if (days + hours + minutes + seconds <= 0) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpiredNotice, {});
    } else {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowCounter, {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        });
    }
};
/* harmony default export */ var CountDown = (CountdownTimer);

;// CONCATENATED MODULE: ./src/components/EntryCTA.tsx



var EntryCTA = function() {
    var ref = (0,index_module/* useStarknet */.CF)(), account = ref.account, connectBrowserWallet = ref.connectBrowserWallet, starknetConnectionError = ref.error, hasStarknet = ref.hasStarknet;
    var ref1 = (0,react.useState)([]), options = ref1[0], setOptions = ref1[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "pt-8 pb-16",
        children: account ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            target: "_blank",
            href: "https://docs.google.com/forms/d/e/1FAIpQLSc66txDM8Ei3w83p3kLJL30VoBS6P7Xep4cIDVACZAbLY05mg/viewform?usp=pp_url&entry.2005620554=".concat(account),
            className: "border px-4 py-2 rounded w-full bg-[#eb5600] hover:bg-[#c94a00] font-body uppercase",
            rel: "noreferrer",
            children: "Get briqs & build"
        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: hasStarknet ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "If you haven't already done so, please",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                rel: "noreferrer",
                                target: "_blank",
                                className: "underline",
                                href: "https://chrome.google.com/webstore/detail/argent-x-starknet-wallet/dlcobpjiigpikoobohmabehhmhfoodbb",
                                children: [
                                    "download and install",
                                    " "
                                ]
                            }),
                            "the ArgentX extension, available now for the Google Chrome web browser."
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "p-4 bg-red-100/30 border-red-700 rounded-md mb-2 text-white",
                        children: [
                            "The ArgentX wallet extension could not be activated. Please",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                rel: "noreferrer",
                                target: "_blank",
                                className: "underline",
                                href: "https://chrome.google.com/webstore/detail/argent-x-starknet-wallet/dlcobpjiigpikoobohmabehhmhfoodbb",
                                children: [
                                    "install ArgentX",
                                    " "
                                ]
                            }),
                            "on a supported browser and revisit this page."
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "border px-4 py-2 rounded w-full bg-[#eb5600] hover:bg-[#c94a00] font-body uppercase",
                    onClick: function() {
                        return connectBrowserWallet();
                    },
                    children: "Connect to ArgentX"
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(9059);
;// CONCATENATED MODULE: ./src/components/Faqs.tsx


var faqs = [
    {
        title: "Do I have to use all 20k briqs per entry?",
        text: "You can use as many briqs as you need, no need to use the entire amount."
    },
    {
        title: "I need more briqs to build my wonders, what should I do?",
        text: "Drop us a message in Discord and we\u2019ll see what we can do."
    },
    {
        title: "Can I use other voxel builders like Magica Voxel?",
        text: 'Yes! Build your wonder in Magica Voxel then save the .vox file. Go to realms.briq.construction, click on "Manage sets", then click on "import file" and select the .vox file.'
    },
    {
        title: "Are there any costs involved in receiving briqs, building or minting the NFT entry?",
        text: "Nope! All free"
    },
    {
        title: "Do I have to tweet your creation to enter? What if I don\u2019t have Twitter?",
        text: "Yes, this is a requirement for entry. There is no time like now to get an account!"
    },
    {
        title: "How were the Wonders chosen?",
        text: "They were carefully chosen by the Bibliotheca DAO core team to ensure a variety of different styles."
    },
    {
        title: " I have an issue, what should I do?",
        text: "Send us a message on Discord and the team will help you out."
    },
    {
        title: "Do I need an Argent X wallet?",
        text: "Yes, this is the only wallet that can currently be used on StarkNet. It is very quick and simple to create one - you can do this here"
    },
    {
        title: "Can I win more than once?",
        text: "Yes, if you have multiple entries across different Wonders, you have the chance of winning more than once as voted by the Bibliotheca DAO."
    }, 
];
var FaqBlock = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "container justify-center flex mx-auto my-20",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "sm:w-1/2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "mb-8 text-center",
                    children: "FAQs"
                }),
                faqs.map(function(a, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(headlessui_esm/* Disclosure */.pJ, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Disclosure.Button */.pJ.Button, {
                                className: "w-full my-2 py-2 bg-gray-1000 rounded px-8 hover:bg-gray-900 transition-all duration-300",
                                children: a.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(headlessui_esm/* Disclosure.Panel */.pJ.Panel, {
                                className: "text-gray-200 py-4 px-4",
                                children: a.text
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(6577);
;// CONCATENATED MODULE: ./src/data/Projects.ts
var projects = [
    {
        name: "Bibliotheca DAO",
        discord: "https://discord.gg/uQnjZhZPfu",
        twitter: "https://twitter.com/LootRealms",
        website: "https://atlas.bibliothecadao.xyz"
    },
    {
        name: "Briqs",
        discord: "https://discord.gg/7X9gJQ3ed9",
        twitter: "https://twitter.com/briqNFT",
        website: "https://realms.briq.construction/"
    },
    {
        name: "Play Oasis",
        discord: "https://discord.gg/ZGRxkeYKNq",
        twitter: "https://twitter.com/PlayOasisXYZ",
        website: "https://testnet.playoasis.xyz/"
    },
    {
        name: "StarkWare",
        discord: "https://discord.gg/XzvgKTTptb",
        twitter: "https://twitter.com/StarkWareLtd",
        website: "https://starkware.co/starknet/"
    }, 
];

;// CONCATENATED MODULE: ./src/components/FooterBlock.tsx



var footerLinkStyles = "hover:underline transition-all duration-300";
var FooterBlock = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "container grid gap-2 grid-cols-2 sm:grid-cols-4 mx-auto p-10 sm:p-20",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    className: "rounded mb-10",
                    alt: "Vercel logo",
                    src: "/bibliotheca-logo.jpg",
                    width: 200,
                    height: 200
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "mb-6",
                        children: "Websites"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: projects.map(function(a, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: footerLinkStyles,
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: a.website,
                                        children: a.name
                                    }),
                                    " "
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "mb-6",
                        children: "Discords"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: projects.map(function(a, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: footerLinkStyles,
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: a.discord,
                                        children: a.name
                                    }),
                                    " "
                                ]
                            }, index);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                        className: "mb-6",
                        children: "Twitters"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        children: projects.map(function(a, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                className: footerLinkStyles,
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: a.twitter,
                                        children: a.name
                                    }),
                                    " "
                                ]
                            }, index);
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(7729);
;// CONCATENATED MODULE: ./src/components/Head.tsx

// Imports
 // Meta
var meta = {
    title: "Realms x briq x PlayOasis",
    description: "A competion run by leading gaming and nft platforms operating on StarkNet.",
    website: "https://bibliothecadao.xyz/",
    image: "https://i.ibb.co/XYPNdCT/Screenshot-2022-02-21-132035.png"
};
function Head() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(head["default"], {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: meta.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "title",
                content: meta.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: meta.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: meta.website
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: meta.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: meta.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: meta.image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:url",
                content: meta.website
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:title",
                content: meta.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:description",
                content: meta.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "twitter:image",
                content: meta.image
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                href: "/favicon.ico"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://fonts.googleapis.com"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "preconnect",
                href: "https://fonts.gstatic.com",
                crossOrigin: "true"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                href: "https://fonts.googleapis.com/css2?family=EB+Garamond:wght@400;700&family=Inconsolata:wght@300&display=swap",
                rel: "stylesheet"
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/next/link.js
var next_link = __webpack_require__(9097);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/tailwind-merge/dist/lib/tailwind-merge.mjs + 9 modules
var tailwind_merge = __webpack_require__(7579);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/base/spinner/loading-bricks.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var LoadingBricks = function(_param) {
    var props = _extends({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", _objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 100 100",
        fill: "none",
        preserveAspectRatio: "xMidYMid",
        "aria-hidden": "true",
        focusable: "false"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                fill: "currentColor",
                x: "13",
                y: "13",
                width: "30",
                height: "30",
                rx: "100",
                ry: "100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "x",
                        dur: "2s",
                        repeatCount: "indefinite",
                        keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
                        values: "13;57;57;57;57;13;13;13;13",
                        begin: "-1.8333333333333333s"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "2s",
                        repeatCount: "indefinite",
                        keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
                        values: "13;57;57;57;57;13;13;13;13",
                        begin: "-1.3333333333333333s"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                fill: "currentColor",
                x: "13",
                y: "13",
                width: "30",
                height: "30",
                rx: "100",
                ry: "100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "x",
                        dur: "2s",
                        repeatCount: "indefinite",
                        keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
                        values: "13;57;57;57;57;13;13;13;13",
                        begin: "-1.1666666666666667s"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "2s",
                        repeatCount: "indefinite",
                        keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
                        values: "13;57;57;57;57;13;13;13;13",
                        begin: "-0.6666666666666666s"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("rect", {
                fill: "currentColor",
                x: "13",
                y: "13",
                width: "30",
                height: "30",
                rx: "100",
                ry: "100",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "x",
                        dur: "2s",
                        repeatCount: "indefinite",
                        keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
                        values: "13;57;57;57;57;13;13;13;13",
                        begin: "-0.5s"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("animate", {
                        attributeName: "y",
                        dur: "2s",
                        repeatCount: "indefinite",
                        keyTimes: "0;0.083;0.25;0.333;0.5;0.583;0.75;0.833;1",
                        values: "13;57;57;57;57;13;13;13;13",
                        begin: "0s"
                    })
                ]
            })
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/ui-lib/src/base/spinner/loading-circle.tsx
function loading_circle_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function loading_circle_extends() {
    loading_circle_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return loading_circle_extends.apply(this, arguments);
}
function loading_circle_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            loading_circle_defineProperty(target, key, source[key]);
        });
    }
    return target;
}

var LoadingCircle = function(_param) {
    var props = loading_circle_extends({}, _param);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", loading_circle_objectSpread({
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        focusable: "false"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                className: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                strokeWidth: "4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                className: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            })
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/ui-lib/src/base/spinner/spinner.tsx
function spinner_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function spinner_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            spinner_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var STYLES = {
    size: {
        xs: "h-3 w-3",
        sm: "h-4 w-4",
        md: "h-6 w-6",
        lg: "h-8 w-8",
        xl: "h-10 w-10"
    },
    scheme: {
        black: "text-gray-900",
        white: "text-white",
        blue: "text-blue-600"
    },
    variant: {
        circle: LoadingCircle,
        bricks: LoadingBricks
    }
};
var Spinner = function(_param) {
    var _size = _param.size, size = _size === void 0 ? "md" : _size, _scheme = _param.scheme, scheme = _scheme === void 0 ? "black" : _scheme, _variant = _param.variant, variant = _variant === void 0 ? "bricks" : _variant, _srLabel = _param.srLabel, srLabel = _srLabel === void 0 ? "Loading..." : _srLabel, _center = _param.center, center = _center === void 0 ? false : _center, className = _param.className, props = _objectWithoutProperties(_param, [
        "size",
        "scheme",
        "variant",
        "srLabel",
        "center",
        "className"
    ]);
    var Spinner1 = STYLES.variant[variant];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", spinner_objectSpread({
        className: (0,clsx_m/* default */.Z)("flex items-center", center && "justify-center", className),
        role: "status"
    }, props, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner1, {
                className: (0,clsx_m/* default */.Z)(variant === "circle" && "animate-spin", STYLES.size[size], STYLES.scheme[scheme])
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: srLabel
            })
        ]
    }));
};


;// CONCATENATED MODULE: ../../packages/ui-lib/src/base/button/ButtonOrLink.tsx
function ButtonOrLink_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ButtonOrLink_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ButtonOrLink_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ButtonOrLink_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = ButtonOrLink_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function ButtonOrLink_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var ButtonOrLink_STYLES = {
    icon: "rounded-2xl bg-gray-500 border-gray-600 text-gray-200 ",
    base: "relative inline-flex items-center justify-center tracking-veryWide outline-none select-none border-2 text-left outline-none rounded transition duration-150 ease-in-out font-body uppercase hover:-translate-y-1 active:translate-y-1 active:shadow-inner font-semibold",
    active: "focus-visible:ring focus-visible:ring-offset-2 focus-visible:ring-offset-white",
    disabled: "disabled:opacity-70 disabled:pointer-events-none",
    size: {
        base: {
            xs: "py-1 px-4 text-xs",
            sm: "py-2 px-4 text-sm",
            md: "py-2 px-4 text-md",
            lg: "py-2 px-4 text-lg"
        },
        icon: {
            xs: "p-1 text-xs",
            sm: "p-2 text-sm",
            md: "p-3 text-md",
            lg: "p-4 text-lg"
        }
    },
    variant: {
        default: "text-gray-600 bg-gray-100 hover:bg-gray-200 active:bg-gray-300 active:text-gray-900 hover:text-gray-900",
        primary: "text-white bg-off-200 hover:bg-off-200/80 focus-visible:ring-yellow-700 border-off-200 shadow-md ",
        secondary: "bg-gray-600 text-white border-gray-600 hover:bg-gray-400 hover:text-gray-800 active:text-gray-900  active:bg-gray-200 shadow-md ",
        tertiary: "text-gray-500 bg-white hover:text-gray-900 hover:bg-gray-100 active:bg-gray-200 active:text-gray-900",
        danger: "text-red-600 focus-visible:bg-red-100 focus-visible:ring-red-600 active:bg-red-200 hover:bg-red-100",
        link: "!p-0 font-semibold text-green-600 focus-visible:ring-transparent focus:underline hover:underline",
        outline: "text-gray-500 hover:text-gray-900 hover:bg-gray-100 active:bg-gray-200 active:text-gray-900",
        unstyled: ""
    }
};
var getButtonStyles = function() {
    return ButtonOrLink_STYLES;
};
var ButtonOrLink = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var href = _param.href, _replace = _param.replace, replace = _replace === void 0 ? false : _replace, _preserveRedirect = _param.preserveRedirect, preserveRedirect = _preserveRedirect === void 0 ? false : _preserveRedirect, _size = _param.size, size = _size === void 0 ? "md" : _size, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, _isIconButton = _param.isIconButton, isIconButton = _isIconButton === void 0 ? false : _isIconButton, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _loading = _param.loading, loading = _loading === void 0 ? false : _loading, loadingText = _param.loadingText, _spinner = _param.spinner, spinner = _spinner === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {
        variant: "circle",
        size: "sm"
    }) : _spinner, className = _param.className, _texture = _param.texture, texture = _texture === void 0 ? true : _texture, children = _param.children, leftIcon = _param.leftIcon, rightIcon = _param.rightIcon, disabled = _param.disabled, props = ButtonOrLink_objectWithoutProperties(_param, [
        "href",
        "replace",
        "preserveRedirect",
        "size",
        "variant",
        "isIconButton",
        "fullWidth",
        "loading",
        "loadingText",
        "spinner",
        "className",
        "texture",
        "children",
        "leftIcon",
        "rightIcon",
        "disabled"
    ]);
    var router = (0,next_router.useRouter)();
    var isLink = typeof href !== "undefined";
    var ButtonOrLink1 = isLink ? "a" : "button";
    var classes = variant === "unstyled" ? className : (0,clsx_m/* default */.Z)(ButtonOrLink_STYLES.base, ButtonOrLink_STYLES.disabled, ButtonOrLink_STYLES.active, isIconButton ? ButtonOrLink_STYLES.icon : ButtonOrLink_STYLES.variant[variant], isIconButton ? ButtonOrLink_STYLES.size.icon[size] : ButtonOrLink_STYLES.size.base[size], fullWidth && "w-full");
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonOrLink1, ButtonOrLink_objectSpread({
        ref: ref,
        className: (0,tailwind_merge/* twMerge */.m)(classes, className),
        disabled: disabled || loading
    }, props, {
        children: [
            texture && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                className: "".concat(isIconButton ? "rounded-2xl bg-center absolute w-full bg-cover h-full opacity-20" : "bg-center absolute w-full bg-cover h-full opacity-20"),
                src: "/texture-button.png",
                alt: ""
            }),
            (leftIcon || loading) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "mr-3.5",
                children: loading ? spinner : leftIcon
            }),
            loading ? loadingText || children : children,
            rightIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "ml-3.5",
                children: rightIcon
            })
        ]
    }));
    if (isLink) {
        var finalHref = preserveRedirect && router.query.redirect ? "".concat(href, "?redirect=").concat(encodeURIComponent(router.query.redirect)) : href;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: finalHref,
            passHref: true,
            replace: true,
            children: content
        });
    }
    return content;
});

ButtonOrLink.displayName = "ButtonOrLink";

;// CONCATENATED MODULE: ../../packages/ui-lib/src/base/button/Button.tsx
function Button_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Button_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Button_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function Button_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = Button_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Button_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var Button = /*#__PURE__*/ (0,react.forwardRef)(function(_param, ref) {
    var _type = _param.type, type = _type === void 0 ? "button" : _type, props = Button_objectWithoutProperties(_param, [
        "type"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonOrLink, Button_objectSpread({
        ref: ref,
        type: type
    }, props));
});

Button.displayName = "Button";

;// CONCATENATED MODULE: ./src/components/ProjectBlock.tsx




var ProjectBlock = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "grid gap-8 sm:grid-cols-2 sm:text-2xl",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-10 px-14",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        className: "rounded mb-10",
                        alt: "Vercel logo",
                        src: "/realms-logo.jpg",
                        width: 180,
                        height: 80
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "8000 procedurally generated maps with unique names, resources and geographical traits. 50 ultra rare Realms contain a unique Wonder."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex mx-auto gap-2 w-full justify-center my-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                size: "sm",
                                href: projects[0].website,
                                variant: "secondary",
                                children: "Atlas"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                size: "sm",
                                href: projects[0].discord,
                                variant: "secondary",
                                children: "Discord"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-10 px-14",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        className: "rounded mb-10",
                        alt: "Vercel logo",
                        src: "/briq.jpg",
                        width: 80,
                        height: 80
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "NFT building protocol based on fundamental particles called briqs that can be assembled to create NFTs. briq is NFT matter."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex mx-auto gap-2 w-full justify-center my-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                size: "sm",
                                href: projects[1].website,
                                variant: "secondary",
                                children: "website"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                size: "sm",
                                href: projects[1].discord,
                                variant: "secondary",
                                children: "Discord"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-10 px-14",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        className: "rounded mb-10",
                        alt: "Vercel logo",
                        src: "/oasis.svg",
                        width: 80,
                        height: 80
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "PlayOasis is a general-purpose NFT marketplace powered by StarkNet. Make offers and list NFTs with near-zero gas fees."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex mx-auto gap-2 w-full justify-center my-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                size: "sm",
                                href: projects[2].website,
                                variant: "secondary",
                                children: "website"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                size: "sm",
                                href: projects[2].discord,
                                variant: "secondary",
                                children: "Discord"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-10 px-14",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        className: "rounded mb-10",
                        alt: "Vercel logo",
                        src: "/starknet.svg",
                        width: 180,
                        height: 80
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "StarkNet is a permissionless decentralized ZK-Rollup. It operates as an L2 network over Ethereum, enabling any dApp to achieve unlimited scale for its computation \u2013 without compromising Ethereum's composability and security."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex mx-auto gap-2 w-full justify-center my-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                size: "sm",
                                href: projects[3].website,
                                variant: "secondary",
                                children: "website"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                size: "sm",
                                href: projects[3].discord,
                                variant: "secondary",
                                children: "Discord"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/anger.svg
var _path;

function anger_extends() { anger_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return anger_extends.apply(this, arguments); }



const SvgAnger = props => /*#__PURE__*/react.createElement("svg", anger_extends({
  viewBox: "0 0 56 92",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.406 0a4 4 0 0 1 2.872 1.255C36.693 8.055 47 20.815 47 41.305c0 10.051-2.142 19.335-5.303 26.893-2.659 6.356-6.146 11.74-9.92 15.302H52a4 4 0 0 1 0 8H4a4 4 0 0 1 0-8h18.662a29.769 29.769 0 0 1-3.402-3.91c-2.795-3.356-5.35-7.394-7.447-11.815C8.347 60.465 6 51.827 6 43c0-8.995 3.022-17.761 6.738-24.995C16.46 10.761 21.034 4.75 24.511 1.201A4 4 0 0 1 27.406 0ZM39 41.304c0 .945-.021 1.882-.063 2.81-2.183-6.402-5.862-11.241-9.875-13.573a4 4 0 0 0-4.14.074c-3.642 2.292-6.826 6.523-9.074 11.2a40.228 40.228 0 0 0-1.74 4.226A43.168 43.168 0 0 1 14 43c0-7.283 2.478-14.767 5.854-21.34 2.372-4.615 5.11-8.632 7.53-11.636C32.828 16.527 39 26.564 39 41.304ZM25.567 74.661c.5.593 1.003 1.152 1.508 1.676 1.045-1.363 2.121-3.16 3.076-5.368C31.835 67.077 33 62.224 33 56.957c0-8.596-3.05-14.73-5.902-17.788-1.369 1.458-2.799 3.53-4.039 6.111C21.202 49.146 20 53.686 20 58c0 4.296 1.193 8.653 3.045 12.43a29.52 29.52 0 0 0 2.522 4.23Z",
  fill: "#89192D"
})));

/* harmony default export */ var anger = (SvgAnger);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/brilliance.svg
var brilliance_path;

function brilliance_extends() { brilliance_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return brilliance_extends.apply(this, arguments); }



const SvgBrilliance = props => /*#__PURE__*/react.createElement("svg", brilliance_extends({
  viewBox: "0 0 88 95",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), brilliance_path || (brilliance_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43 0c.345 0 .68.044 1 .126A4 4 0 0 1 49 4c0 16.053 6 25.62 13.112 31.267C69.402 41.054 78.225 43 84 43a4 4 0 0 1 3.97 4.5A4 4 0 0 1 84 52c-5.775 0-14.599 1.946-21.888 7.733C54.999 65.379 49 74.947 49 91a4 4 0 0 1-5 3.874A4.005 4.005 0 0 1 39 91c0-16.053-6-25.62-13.112-31.267C18.598 53.946 9.775 52 4 52a4 4 0 0 1-3.97-4.5A4 4 0 0 1 4 43c5.775 0 14.599-1.946 21.888-7.733C33.001 29.621 39 20.053 39 4a4 4 0 0 1 4-4ZM20.703 47.5c3.448 1.442 6.916 3.393 10.159 5.967C36.375 57.844 41.111 63.924 44 72.09c2.889-8.166 7.625-14.246 13.138-18.623 3.243-2.574 6.71-4.525 10.158-5.967-3.447-1.442-6.915-3.393-10.158-5.967C51.625 37.156 46.889 31.076 44 22.91c-2.889 8.166-7.625 14.246-13.138 18.623-3.243 2.574-6.71 4.525-10.159 5.967Z",
  fill: "#7DFFBA"
})));

/* harmony default export */ var brilliance = (SvgBrilliance);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/detection.svg
var detection_path;

function detection_extends() { detection_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return detection_extends.apply(this, arguments); }



const SvgDetection = props => /*#__PURE__*/react.createElement("svg", detection_extends({
  viewBox: "0 0 81 81",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), detection_path || (detection_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.212.001 40.5 0C62.867 0 81 18.133 81 40.5S62.867 81 40.5 81 0 62.867 0 40.5C0 18.768 17.116 1.034 38.603.044A22.334 22.334 0 0 1 40.213 0Zm-21.485 16.37C12.14 22.32 8 30.927 8 40.5 8 58.45 22.55 73 40.5 73S73 58.45 73 40.5c0-10.205-4.704-19.312-12.061-25.27A21.984 21.984 0 0 1 62 22c0 12.15-9.85 22-22 22s-22-9.85-22-22c0-1.945.253-3.832.727-5.628Zm20.321-8.34a33.04 33.04 0 0 1 1.15-.03C47.838 8.107 54 14.334 54 22c0 7.732-6.268 14-14 14s-14-6.268-14-14c0-7.412 5.76-13.479 13.048-13.968Z",
  fill: "#139757"
})));

/* harmony default export */ var detection = (SvgDetection);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/enlightenment.svg
var enlightenment_path;

function enlightenment_extends() { enlightenment_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return enlightenment_extends.apply(this, arguments); }



const SvgEnlightenment = props => /*#__PURE__*/react.createElement("svg", enlightenment_extends({
  viewBox: "0 0 81 88",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), enlightenment_path || (enlightenment_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8 40.5C8 22.55 22.55 8 40.5 8S73 22.55 73 40.5 58.45 73 40.5 73 8 58.45 8 40.5ZM40.5 0C18.133 0 0 18.133 0 40.5c0 18.57 12.498 34.22 29.542 39H9a4 4 0 0 0 0 8h64a4 4 0 0 0 0-8H51.458C68.502 74.72 81 59.07 81 40.5 81 18.133 62.867 0 40.5 0Z",
  fill: "#1380FF"
})));

/* harmony default export */ var enlightenment = (SvgEnlightenment);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/fox.svg
var fox_path;

function fox_extends() { fox_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return fox_extends.apply(this, arguments); }



const SvgFox = props => /*#__PURE__*/react.createElement("svg", fox_extends({
  viewBox: "0 0 71 89",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), fox_path || (fox_path = /*#__PURE__*/react.createElement("path", {
  d: "M66.5 54.5 36 85h-1.5L4 54.5V4l19 19h24.5l19-19v50.5Z",
  stroke: "#D47230",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ var fox = (SvgFox);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/fury.svg
var fury_path;

function fury_extends() { fury_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return fury_extends.apply(this, arguments); }



const SvgFury = props => /*#__PURE__*/react.createElement("svg", fury_extends({
  viewBox: "0 0 72 73",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), fury_path || (fury_path = /*#__PURE__*/react.createElement("path", {
  d: "M4 69C4 19 68 4 68 4c-12.333 16-31.4 51.4-9 65",
  stroke: "#82005E",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ var fury = (SvgFury);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/giants.svg
var giants_path;

function giants_extends() { giants_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return giants_extends.apply(this, arguments); }



const SvgGiants = props => /*#__PURE__*/react.createElement("svg", giants_extends({
  viewBox: "0 0 65 79",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), giants_path || (giants_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.828 1.172a4 4 0 0 0-5.656 0L18.858 12.485a4 4 0 0 0 0 5.657l7.921 7.922L1.172 51.672A4 4 0 0 0 0 54.5v20a4 4 0 0 0 8 0V56.157l24.5-24.5 24.5 24.5V74.5a4 4 0 0 0 8 0v-20a4 4 0 0 0-1.172-2.828L38.721 26.564l8.421-8.422a4 4 0 0 0 0-5.657L35.828 1.172Zm-8.485 14.142L33 9.657l5.657 5.657L33 20.97l-5.657-5.657Z",
  fill: "#EB544D"
})));

/* harmony default export */ var giants = (SvgGiants);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/perfection.svg
var perfection_path;

function perfection_extends() { perfection_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return perfection_extends.apply(this, arguments); }



const SvgPerfection = props => /*#__PURE__*/react.createElement("svg", perfection_extends({
  viewBox: "0 0 73 73",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), perfection_path || (perfection_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.947 4.197A4 4 0 0 0 68.84 1.2c-3.975-.795-8.924.058-13.523 1.787-4.697 1.765-9.567 4.642-13.424 8.5-2.34 2.338-4.274 5.005-5.814 7.775a44.695 44.695 0 0 0-6.207-7.776C25.523 7.14 20.8 4.227 16.377 2.563 12.037.932 7.692.4 4.197 1.232A4 4 0 0 0 1.2 4.339c-.795 3.974.058 8.924 1.787 13.523 1.765 4.697 4.642 9.567 8.5 13.424 2.338 2.34 5.005 4.273 7.775 5.814a44.7 44.7 0 0 0-7.776 6.207C7.14 47.655 4.227 52.378 2.563 56.8.932 61.141.4 65.487 1.232 68.983a4 4 0 0 0 3.107 2.996c3.974.795 8.924-.058 13.523-1.787 4.697-1.765 9.567-4.642 13.424-8.5 2.34-2.339 4.273-5.006 5.814-7.775a44.7 44.7 0 0 0 6.207 7.776c4.348 4.348 9.071 7.26 13.494 8.923 4.34 1.632 8.686 2.164 12.181 1.332a4 4 0 0 0 2.996-3.107c.795-3.975-.058-8.924-1.787-13.523-1.765-4.697-4.642-9.567-8.5-13.424-2.339-2.34-5.006-4.274-7.775-5.814a44.7 44.7 0 0 0 7.776-6.207c4.348-4.349 7.26-9.072 8.923-13.495 1.632-4.34 2.164-8.685 1.332-12.18Zm-39.73 25.072c-.204.89-.37 1.775-.495 2.646a30.63 30.63 0 0 0-2.737.69 30.27 30.27 0 0 1-1.465-.495c-3.736-1.372-7.456-3.561-10.376-6.48-2.931-2.932-5.24-6.782-6.668-10.583-.865-2.303-1.342-4.405-1.507-6.135 1.292.135 2.844.482 4.593 1.14 3.32 1.248 7.082 3.52 10.653 7.092 3.576 3.576 6.12 7.615 7.679 11.325.114.27.221.537.323.8Zm-2.948 11.693c-.263.102-.53.21-.8.323-3.71 1.559-7.749 4.102-11.325 7.679-3.571 3.57-5.844 7.333-7.092 10.653-.658 1.749-1.005 3.3-1.14 4.593 1.73-.166 3.832-.642 6.135-1.507 3.8-1.429 7.65-3.737 10.582-6.668 2.92-2.92 5.109-6.64 6.48-10.377.182-.493.347-.982.496-1.464a30.641 30.641 0 0 1-.69-2.737 33.006 33.006 0 0 1-2.646-.495Zm11.995-9.24c.871.125 1.755.291 2.645.495.264-.102.53-.21.8-.323 3.711-1.559 7.75-4.103 11.326-7.679 3.57-3.571 5.844-7.334 7.092-10.653.658-1.749 1.005-3.3 1.14-4.593-1.73.165-3.833.642-6.135 1.507-3.8 1.428-7.651 3.737-10.582 6.668-2.92 2.92-5.11 6.64-6.48 10.376-.182.494-.347.983-.497 1.465.278.924.509 1.838.69 2.736Zm.193 9.542a33.012 33.012 0 0 1-.495 2.645c.102.264.21.53.323.8 1.559 3.711 4.102 7.75 7.679 11.326 3.57 3.57 7.333 5.844 10.653 7.092 1.749.658 3.3 1.005 4.593 1.14-.166-1.73-.642-3.833-1.507-6.135-1.429-3.8-3.737-7.651-6.668-10.582-2.92-2.92-6.64-5.11-10.377-6.48a30.304 30.304 0 0 0-1.464-.497c-.924.278-1.839.509-2.737.69Z",
  fill: "#8E35FF"
})));

/* harmony default export */ var perfection = (SvgPerfection);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/power.svg
var power_path;

function power_extends() { power_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return power_extends.apply(this, arguments); }



const SvgPower = props => /*#__PURE__*/react.createElement("svg", power_extends({
  viewBox: "0 0 49 92",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), power_path || (power_path = /*#__PURE__*/react.createElement("path", {
  d: "M4 50 31 4l-5 31h19L17 88l6-38H4Z",
  stroke: "#F4B547",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ var power = (SvgPower);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/protection.svg
var protection_path;

function protection_extends() { protection_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return protection_extends.apply(this, arguments); }



const SvgProtection = props => /*#__PURE__*/react.createElement("svg", protection_extends({
  viewBox: "0 0 80 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), protection_path || (protection_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.233 8.22C21.57 9.938 9.939 21.57 8.219 36.232L36.233 8.219ZM8.293 44.346c1.928 14.195 13.165 25.432 27.36 27.36l-27.36-27.36Zm35.042 27.481c15.01-1.554 26.94-13.483 28.493-28.493L43.335 71.828ZM71.88 37.224C70.553 21.766 58.234 9.447 42.776 8.12L71.88 37.224ZM40 0C17.909 0 0 17.909 0 40s17.909 40 40 40 40-17.909 40-40S62.091 0 40 0ZM15.513 40.253l24.042-24.042 24.041 24.042-24.041 24.042-24.042-24.042Z",
  fill: "#00C3A1"
})));

/* harmony default export */ var protection = (SvgProtection);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/rage.svg
var rage_path;

function rage_extends() { rage_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return rage_extends.apply(this, arguments); }



const SvgRage = props => /*#__PURE__*/react.createElement("svg", rage_extends({
  viewBox: "0 0 73 88",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), rage_path || (rage_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M62.342 5.113a4 4 0 1 0-7.684-2.224L41.75 47.501h-10.08l-9.764-44.36a4 4 0 1 0-7.813 1.72l9.386 42.64H4a4 4 0 0 0 0 8h21.24l6.354 28.86a4 4 0 0 0 7.748.252L47.765 55.5H69a4 4 0 1 0 0-8H50.08L62.341 5.113ZM39.437 55.5h-6.005l2.595 11.786 3.41-11.786Z",
  fill: "#C74800"
})));

/* harmony default export */ var rage = (SvgRage);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/reflection.svg
var reflection_path;

function reflection_extends() { reflection_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return reflection_extends.apply(this, arguments); }



const SvgReflection = props => /*#__PURE__*/react.createElement("svg", reflection_extends({
  viewBox: "0 0 61 86",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), reflection_path || (reflection_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30 0a4 4 0 0 1 4 4v32.343l19.672-19.671A4 4 0 0 1 60.5 19.5v49a4 4 0 0 1-6.828 2.828L34 51.657V82a4 4 0 0 1-8 0V52.157L6.828 71.328A4 4 0 0 1 0 68.5v-49a4 4 0 0 1 6.828-2.828L26 35.843V4a4 4 0 0 1 4-4Zm7.657 44L52.5 58.843V29.157L37.657 44ZM8 58.843 22.843 44 8 29.157v29.686Z",
  fill: "#00A2AA"
})));

/* harmony default export */ var reflection = (SvgReflection);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/skill.svg
var skill_path;

function skill_extends() { skill_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return skill_extends.apply(this, arguments); }



const SvgSkill = props => /*#__PURE__*/react.createElement("svg", skill_extends({
  viewBox: "0 0 68 88",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), skill_path || (skill_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.818 0a4 4 0 0 1 2.889 1.172l30.682 30.683a4 4 0 0 1-5.656 5.656L37 13.78v20.686l29.39 29.39a4 4 0 0 1-5.657 5.656L37 45.78V83.5a4 4 0 1 1-8 0V45.957L6.913 69.424a4 4 0 1 1-5.826-5.483L29 34.284V13.957L6.913 37.424a4 4 0 1 1-5.826-5.482L29.965 1.259A4 4 0 0 1 32.818 0Z",
  fill: "#706DFF"
})));

/* harmony default export */ var skill = (SvgSkill);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/titans.svg
var titans_path;

function titans_extends() { titans_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return titans_extends.apply(this, arguments); }



const SvgTitans = props => /*#__PURE__*/react.createElement("svg", titans_extends({
  viewBox: "0 0 68 82",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), titans_path || (titans_path = /*#__PURE__*/react.createElement("path", {
  d: "M4 78V34.683L32.878 4m0 0 30.683 30.683V78M32.878 4v74",
  stroke: "#EC68A8",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ var titans = (SvgTitans);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/twins.svg
var twins_path;

function twins_extends() { twins_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return twins_extends.apply(this, arguments); }



const SvgTwins = props => /*#__PURE__*/react.createElement("svg", twins_extends({
  viewBox: "0 0 72 86",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), twins_path || (twins_path = /*#__PURE__*/react.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72 4.5a4 4 0 0 1-4 4H55V78h13a4 4 0 0 1 0 8H4a4 4 0 0 1 0-8h11V8.5H4a4 4 0 1 1 0-8h64a4 4 0 0 1 4 4ZM23 78h24V8.5H23V78Z",
  fill: "#0020C6"
})));

/* harmony default export */ var twins = (SvgTwins);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/icons/orders/vitriol.svg
var vitriol_path;

function vitriol_extends() { vitriol_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return vitriol_extends.apply(this, arguments); }



const SvgVitriol = props => /*#__PURE__*/react.createElement("svg", vitriol_extends({
  viewBox: "0 0 81 87",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), vitriol_path || (vitriol_path = /*#__PURE__*/react.createElement("path", {
  d: "M43.5 4 4 43.5 43.5 83M68.538 66.403 33.962 51.097M68.5 22 34 37.5M76.16 43.64l-23.82.22",
  stroke: "#59A509",
  strokeWidth: 8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

/* harmony default export */ var vitriol = (SvgVitriol);
;// CONCATENATED MODULE: ../../packages/ui-lib/src/base/order-icon/order-icon.tsx


















var Components = Object.freeze({
    power: /*#__PURE__*/ (0,jsx_runtime.jsx)(power, {}),
    anger: /*#__PURE__*/ (0,jsx_runtime.jsx)(anger, {}),
    brilliance: /*#__PURE__*/ (0,jsx_runtime.jsx)(brilliance, {}),
    detection: /*#__PURE__*/ (0,jsx_runtime.jsx)(detection, {}),
    enlightenment: /*#__PURE__*/ (0,jsx_runtime.jsx)(enlightenment, {}),
    "the fox": /*#__PURE__*/ (0,jsx_runtime.jsx)(fox, {}),
    fury: /*#__PURE__*/ (0,jsx_runtime.jsx)(fury, {}),
    giants: /*#__PURE__*/ (0,jsx_runtime.jsx)(giants, {}),
    perfection: /*#__PURE__*/ (0,jsx_runtime.jsx)(perfection, {}),
    reflection: /*#__PURE__*/ (0,jsx_runtime.jsx)(reflection, {}),
    skill: /*#__PURE__*/ (0,jsx_runtime.jsx)(skill, {}),
    titans: /*#__PURE__*/ (0,jsx_runtime.jsx)(titans, {}),
    "the twins": /*#__PURE__*/ (0,jsx_runtime.jsx)(twins, {}),
    vitriol: /*#__PURE__*/ (0,jsx_runtime.jsx)(vitriol, {}),
    rage: /*#__PURE__*/ (0,jsx_runtime.jsx)(rage, {}),
    protection: /*#__PURE__*/ (0,jsx_runtime.jsx)(protection, {})
});
var order_icon_STYLES = {
    size: {
        xs: "w-4 h-4 my-4 flex",
        sm: "w-6 h-6 my-4 flex",
        md: "w-8 h-8 my-4 flex",
        lg: "w-12 h-12 my-4 flex"
    }
};
var OrderIcon = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,tailwind_merge/* twMerge */.m)(order_icon_STYLES.size[props.size], props.className),
        children: Components[props.order.replace("_", " ")]
    });
};

;// CONCATENATED MODULE: ./src/components/WonderBlock.tsx


var WonderBlock = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-col border rounded-2xl border-yellow-100/20 p-2 sm:p-6 text-center hover:bg-gray-800/40 transition-all duration-300 transform hover:-translate-y-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(OrderIcon, {
                className: "mx-auto",
                order: props.order,
                size: "lg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                className: "text-gray-500",
                children: [
                    "Order of ",
                    props.order
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                children: props.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex space-x-2 pt-6 justify-around w-full mt-auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        href: "https://opensea.io/assets/0x7afe30cb3e53dba6801aa0ea647a0ecea7cbe18d/" + props.id,
                        className: "w-full",
                        variant: "primary",
                        size: "xs",
                        children: "opensea"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                        href: "https://atlas.bibliothecadao.xyz/?realm=" + props.id,
                        className: "w-full",
                        variant: "primary",
                        size: "xs",
                        children: "atlas"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/data/Orders.ts
var wonders = [
    {
        name: "The Glowing Geyser",
        order: "anger",
        id: "538"
    },
    {
        name: "The Pale Pillar",
        order: "detection",
        id: "1518"
    },
    {
        name: "The Cerulean Chamber",
        order: "fury",
        id: "7083"
    },
    {
        name: "The Pagoda of Fortune",
        order: "rage",
        id: "4749"
    },
    {
        name: "Pantheon Of Chaos",
        order: "reflection",
        id: "1275"
    },
    {
        name: "Altar Of The Void",
        order: "the fox",
        id: "4581"
    },
    {
        name: "Sanctum Of The Oracle",
        order: "the twins",
        id: "2658"
    },
    {
        name: "The Perpetual Fjord",
        order: "vitriol",
        id: "5335"
    },
    {
        name: "Infinity Spire",
        order: "brilliance",
        id: "6196"
    },
    {
        name: "The Ancestral Trees",
        order: "enlightenment",
        id: "6725"
    },
    {
        name: "The Amaranthine Rock",
        order: "giants",
        id: "1461"
    },
    {
        name: "Sanctum Of Purpose",
        order: "perfection",
        id: "4575"
    },
    {
        name: "The Origin Oasis",
        order: "power",
        id: "4363"
    },
    {
        name: "The Mirror Grotto",
        order: "protection",
        id: "3903"
    },
    {
        name: "The Weeping Willow",
        order: "skill",
        id: "4934"
    },
    {
        name: "The Solemn Catacombs",
        order: "titans",
        id: "7179"
    }, 
];

;// CONCATENATED MODULE: ./src/pages/index.tsx











function Home() {
    var ref = (0,index_module/* useStarknet */.CF)(), account = ref.account, connectBrowserWallet = ref.connectBrowserWallet, starknetConnectionError = ref.error, hasStarknet = ref.hasStarknet;
    var ref1 = (0,react.useState)([]), content = ref1[0], setContent = ref1[1];
    (0,react.useEffect)(function() {
        connectBrowserWallet(); // on mount
    }, []);
    var time = function() {
        var END = 1651327190000;
        var NOW_IN_MS = new Date().getTime();
        var MS_UNTIL = END - NOW_IN_MS;
        return (NOW_IN_MS + MS_UNTIL).toString();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "h-full bg-black",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-full h-screen-30 bg-cover bg-hero bg-bottom "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container flex mx-auto flex-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full sm:w-1/2 p-8 sm:py-20",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                children: "A starknet nft competition"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: "Build a Wonder & Win"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "font-display sm:text-2xl mt-8",
                                children: "Realms, Briq, PlayOasis & StarkWare present to you the first cross-project, on-chain, collaborative competition for builders and artists on StarkNet."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full sm:w-1/2 text-center p-10 bg-gray-800/10 rounded self-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            children: [
                                "16 Winners ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                " 48k $LORDS ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "& 1.6 ETH in prizes"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-auto bg-off-200 py-8 flex shadow-inner px-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: "mx-auto uppercase font-semibold",
                    children: "the lore, the builder, the marketplace, the roll-up"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mx-auto flex flex-wrap text-center py-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProjectBlock, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                scrolling: "no",
                src: "https://realms.briq.construction/share?set_id=0x35ee90ec08fa17ab562a06406fc391f574e2a94805403b84000000000000000&network=testnet&version=2&embed=1",
                className: "h-screen-65 w-full",
                title: "Briqs"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container p-10 sm:p-20 mx-auto flex flex-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full sm:w-1/2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mb-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "mb-8",
                                        children: "the competition"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                        className: "text-3xl sm:text-5xl font-display list-decimal list-inside",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Pick a Wonder"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Build and mint it with briqs"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: "Showcase it on PlayOasis"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "mb-8",
                                        children: "what is a wonder?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-3xl sm:text-5xl font-display mb-8",
                                        children: "Wonders are mythical structures, both man-made and naturally formed, scattered throughout the Realmverse."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "sm:text-2xl",
                                        children: [
                                            "While they have been admired and worshipped for eons, their true beauty and image have never been transcribed to share with the wider world.",
                                            " "
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "mb-8",
                                        children: "Calling all builders & artists"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-3xl sm:text-5xl font-display mb-8",
                                        children: "We are calling on all builders, artists and layer 2 trailblazers to create their own visual representation of these sacred sites with briqs, directly on StarkNet."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "sm:text-2xl",
                                        children: [
                                            "Of the 50 Wonders, there will be 16 to choose from to build: one from each of the Orders.",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "All creations will be displayed on PlayOasis in a special Realms category for all to see and worship."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "mb-8",
                                        children: "Voting"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-3xl sm:text-5xl font-display mb-8",
                                        children: "Submissions close on the 30th of April at midnight,then the 16 winners will be chosen by Realm Holders via quadratic voting."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sm:text-2xl",
                                        children: "There will be 16 separate snapshots to decide the winner from each of the Orders."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "my-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                        className: "mb-8",
                                        children: "Prizes"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-3xl sm:text-5xl font-display mb-8",
                                        children: "There is a total prize pool of 48k $LORDS and 1.6 ETH split evenly across the 16 winners."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sm:text-2xl mb-4",
                                        children: "Bibliotheca DAO will award 3000 $LORDS and StarkWare 0.1 eth to each of the winners. The winning NFTs will be minted on StarkNet mainnet and transferred to the winners free of cost. There are no prerequisites; everyone is welcome to participate."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "sm:text-2xl",
                                        children: "You can submit as many as you like and, if voted by the DAO, can win multiple across the different Wonders of the Orders."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full sm:w-1/2 px-8 sm:px-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: " sticky top-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                    children: [
                                        "Time left in ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        " competition submission"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CountDown, {
                                    date: time()
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryCTA, {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full h-auto bg-off-200 py-8 flex shadow-inner",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                    className: "mx-auto uppercase tracking-widest",
                    children: "how to enter"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mx-auto justify-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "sm:w-2/3 p-16 self-start mx-auto",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ol", {
                                className: "leading-loose text-xl sm:text-3xl font-display list-decimal list-inside space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            "Connect your Argent X StarkNet Wallet ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "text-gray-700 text-lg sm:text-2xl",
                                                children: [
                                                    "(create one",
                                                    " ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: "hover:underline",
                                                        href: "https://chrome.google.com/webstore/detail/argent-x-starknet-wallet/dlcobpjiigpikoobohmabehhmhfoodbb",
                                                        children: "here"
                                                    }),
                                                    " ",
                                                    "if you don\u2019t have one and install the browser extension)"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            "Complete the form ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-gray-700 text-lg sm:text-2xl",
                                                children: account ? /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    href: "https://docs.google.com/forms/d/e/1FAIpQLSc66txDM8Ei3w83p3kLJL30VoBS6P7Xep4cIDVACZAbLY05mg/viewform?usp=pp_url&entry.2005620554=".concat(account),
                                                    className: " hover:underline",
                                                    rel: "noreferrer",
                                                    children: "Sign up and & build"
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    rel: "noreferrer",
                                                    target: "_blank",
                                                    className: "hover:underline",
                                                    href: "https://chrome.google.com/webstore/detail/argent-x-starknet-wallet/dlcobpjiigpikoobohmabehhmhfoodbb",
                                                    children: "First download and install Argent"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "20k Briqs will be airdropped to your address (within 24 hours)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            "Choose one of the",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "underline",
                                                href: "#wonders",
                                                children: "16 Wonders"
                                            }),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            "Head to",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "hover:underline text-[#eb5600]",
                                                href: "https://realms.briq.construction/",
                                                children: "briq"
                                            }),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            "Build your chosen Wonder with briqs ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "hover:underline text-gray-700 text-lg sm:text-2xl",
                                                target: "_blank",
                                                href: "https://briqnft.notion.site/Help-center-4a4958337970483dbfc2c1184290b42f",
                                                rel: "noreferrer",
                                                children: "(how to build guide)"
                                            }),
                                            " "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Mint your masterpiece on briq (no fees)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        children: [
                                            "Tweet your masterpiece with the following text: ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "py-8",
                                                children: '"I built the @lootrealms Wonder [NAME] with @briqNFT. We\u2019re trailblazing the way to layer 2 #StarkNet @starkwareLTD. View it on @PlayOasisXYZ.\u201D'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: " View your entry on PlayOasis"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                                className: "my-10"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "my-4",
                                children: "Voting"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Voting will be done via a quadratic snapshot vote by the Realm holders"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "There will be a snapshot per 16 submissions (one from each Order)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Voting will be open for 7 days"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "my-4",
                                children: "Conditions"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Open to everyone"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Should you need more briqs send a DM to the team"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "Unlimited entries"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "One creator can win more than once with multiple entries"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-full flex justify-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EntryCTA, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "wonders",
                className: "flex justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "w-1/2 py-8 text-center mt-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "mb-4",
                            children: "The Wonders"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "sm:text-2xl",
                            children: [
                                "While they have been admired and worshipped for eons, their true beauty and image have never been transcribed to share with the wider world.",
                                " "
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid gap-2 grid-cols-2 sm:grid-cols-4 px-2",
                children: wonders.map(function(a, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(WonderBlock, {
                        name: a.name,
                        id: a.id,
                        order: a.order
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FaqBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {
                className: "mt-10"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterBlock, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative w-full h-screen-30 bg-cover bg-hero bg-bottom "
            })
        ]
    });
}
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [110,774,888,179], function() { return __webpack_exec__(8738); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);